import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorUnion } from 'src/app/common-components/errors/models/error-message';
import { ErrorMessageService } from 'src/app/common-components/errors/services/error-message.service';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-internal-server-error',
    styleUrls: ['internal-server-error.component.scss'],
    templateUrl: 'internal-server-error.component.html',
    standalone: false
})
export class InternalServerErrorComponent implements OnInit, OnDestroy {
   @Input() message = 'Internal Server Error';

   @Input() error: ErrorUnion;

   constructor(public router: Router, private errorMessageService: ErrorMessageService) {}

   ngOnInit(): void {
      this.errorMessageService.preventErrorMessageDialogDisplay();
   }

   ngOnDestroy(): void {
      this.errorMessageService.allowErrorMessageDialogDisplay();
   }

   showErrorDetails(): void {
      if (this.error) {
         this.errorMessageService.allowErrorMessageDialogDisplay();
         this.errorMessageService.openErrorDialog(this.error);
      }
   }

   reloadPage(): void {
      location.reload();
   }
}
